import { TInfrastructureBbox } from '../types/map';

export function convertBboxToString(bbox: TInfrastructureBbox) {
  const [[leftBottomLat, leftBottomLng], [topRightLat, topRightLng]] = bbox;

  return `${leftBottomLng},${leftBottomLat}~${topRightLng},${topRightLat}`;
}
